import { STATEMENT_STATUSES } from "@/app/projects/constants";
import { StatusCell } from "@/components/status-cell";
import { ProcessStatementForm } from "./process-statement-form";

const props = {
  [STATEMENT_STATUSES.succeeded]: { label: "Processed", variant: "success" },
  [STATEMENT_STATUSES.failed]: { label: "Error", variant: "error" },
  [STATEMENT_STATUSES.notStarted]: {
    label: "Not started",
    variant: "not_started",
  },
  [STATEMENT_STATUSES.extracting]: {
    label: "Extracting",
    variant: "processing",
  },
  [STATEMENT_STATUSES.categorizing]: {
    label: "Categorizing",
    variant: "processing",
  },
  [STATEMENT_STATUSES.duplicated]: {
    label: "Duplicated",
    variant: "not_started",
  },
};

export const StatementStatusCell = ({ statementId, status }) => (
  <div className="flex items-center gap-1">
    <StatusCell label={props[status].label} variant={props[status].variant} />
    {status === STATEMENT_STATUSES.failed && (
      <div className="flex items-center text-xs text-gray-500">
        (
        <ProcessStatementForm statementId={statementId}>
          retry
        </ProcessStatementForm>
        )
      </div>
    )}
  </div>
);
